/* eslint-disable */
// Generated by infra/scripts/generate-aws-config.js — do not commit secrets.
// Prefer this file over aws-exports.js when present (see App.js).

const awsmobile = {
  "aws_project_region": "eu-west-2",
  "aws_cognito_identity_pool_id": "eu-west-2:d841d4dd-f52e-4579-aec4-14a5a9c222a6",
  "aws_cognito_region": "eu-west-2",
  "aws_user_pools_id": "eu-west-2_gKFmdzQGu",
  "aws_user_pools_web_client_id": "5uvbommnv1an1897r2o5mdpdkq",
  "oauth": {
    "domain": "cyf-dev1.auth.eu-west-2.amazoncognito.com",
    "scope": [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin"
    ],
    "redirectSignIn": "https://dev1.app.compareyourfootprint.com/",
    "redirectSignOut": "https://dev1.app.compareyourfootprint.com/",
    "responseType": "code"
  },
  "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
  "aws_cognito_username_attributes": [
    "EMAIL"
  ],
  "aws_cognito_social_providers": [
    "GOOGLE"
  ],
  "aws_cognito_signup_attributes": [
    "EMAIL"
  ],
  "aws_cognito_mfa_configuration": "OPTIONAL",
  "aws_cognito_mfa_types": [
    "TOTP"
  ],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyMinLength": 8,
    "passwordPolicyCharacters": []
  },
  "aws_cognito_verification_mechanisms": [
    "EMAIL"
  ],
  "aws_cloud_logic_custom": [
    {
      "name": "cyfApi",
      "endpoint": "https://api.dev1.app.compareyourfootprint.com/v1",
      "region": "eu-west-2"
    }
  ]
};

export default awsmobile;
